import { countriesCodes } from '../../../../../../../../utils/data/countryCodes';

export default function createCountryCodeToCountryNameMap() {
  const countryCodeToCountryName = {};

  for (const { code, name } of countriesCodes) {
    countryCodeToCountryName[code] = name;
  }

  return countryCodeToCountryName;
}
